import { scrollParentX } from '../../utilities/nojq/_scrollParent.js';

const isSSR = typeof window === 'undefined';
export default {
    name: 'mvtDropdownList',
    emits: ['update:modelValue', 'opened', 'closed', 'changed'],
    props: {
        label: {
            type: String,
            required: false,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        size: {
            type: String,
            required: false,
            default: 'medium',
        },
        textAlign: {
            type: String,
            default: 'center',
        },
        items: {
            type: Array,
            required: false,
            default: [],
        },
        modelValue: {
            default: 0,
            required: false,
        },
        defaultValue: {
            required: false,
            default: undefined,
        },
        hideReset: {
            type: Boolean,
            required: false,
            default: false,
        },
        btnClass: {
            type: String,
            required: false,
            default: 'toggle',
        },
    },
    data() {
        return {
            active: false,
            filteredItems: [],
            registeredEvents: false,
        };
    },
    methods: {
        reposition() {
            const parent = scrollParentX(this.$el) || document.body;
            const list = this.$el.querySelector('.mvt-dropdown__items');
            const pWidth = parent.offsetWidth;
            const lWidth = list.offsetWidth;

            /* Reset current position */
            list.style.left = `0px`;

            const pLeft = !isSSR ? window.scrollX + parent.getBoundingClientRect().left : 0;
            const lLeft = !isSSR ? window.scrollX + list.getBoundingClientRect().left : 0;

            let offset = 0;

            if (pLeft + pWidth < lLeft + lWidth) {
                offset = pLeft + pWidth - (lLeft + lWidth);
            } else if (pLeft > lLeft) {
                offset = pLeft - lLeft;
            }

            if (offset) {
                list.style.left = `${offset}px`;
            } else {
                list.style.left = `0px`;
            }
        },
        toggle() {
            if (!this.active) {
                this.open();
            } else {
                this.close();
            }
        },
        open() {
            this.filteredItems = this.items.filter((item) => item.value != this.modelValue);
            this.active = true;
            this.$emit('opened');
            this.reposition();
            if (!this.registeredEvents) {
                ['touchstart', 'mousedown', 'scroll'].forEach((eventName) => {
                    document.addEventListener(eventName, this.onInteraction);
                });
                this.registeredEvents = true;
            }
        },
        close() {
            this.active = false;
            this.$emit('closed');
        },
        onSelect(e, item) {
            if ((!item.href && !item.onClick) || (item.href && item.onClick)) {
                e.preventDefault();
            }
            if (item.hasOwnProperty('value')) {
                this._value = item.value;
            }
            if (item.onClick) {
                item.onClick(item);
            }
            this.$emit('changed', item);
            this.close();
        },
        reset() {
            if (this.resettable) {
                this._value = this.defaultValue;
                this.$emit('reset');
            }
        },
        onInteraction(event) {
            // here I check that click was outside the el and his children
            if (this.active) {
                if (!(this.$el == event.target || this.$el.contains(event.target))) {
                    this.close();
                }
            }
        },
    },
    computed: {
        _value: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            },
        },
        labelText() {
            if (this._value) {
                const item = this.items?.find((item) => this._value === item.value);
                if (item && (item.hasOwnProperty('labelText') || item.hasOwnProperty('text'))) {
                    return item.labelText || item.text;
                }
            }
            return this.label ? this.label : 'Select...';
        },
        btnSize() {
            if (this.size === 'small') {
                return 'small';
            }
            if (this.size === 'medium') {
                return 'medium';
            }
            if (this.size === 'large') {
                return 'large';
            }
            return 'regular';
        },
        resettable() {
            if (this.hideReset) {
                return false;
            }
            if (this.defaultValue !== undefined) {
                return this.defaultValue !== this._value;
            }
            return false;
        },
    },
    mounted() {
        if (this.defaultValue !== undefined && this.defaultValue !== null && this._value !== this.defaultValue) {
            this._value = this.defaultValue;
        }
    },
    beforeUnmount() {
        ['touchstart', 'mousedown', 'scroll'].forEach((eventName) => {
            document.removeEventListener(eventName, this.onInteraction);
        });
    },
};
